import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { OrderState, StateWithOrder } from '../order-state';
import { getOrderState } from './feature.selector';

const getOrderRepeatState: MemoizedSelector<StateWithOrder, StateUtils.LoaderState<void>> = createSelector(
  getOrderState,
  (state: OrderState) => state.orderRepeat,
);

export const getOrderRepeatLoading = (): MemoizedSelector<StateWithOrder, boolean> =>
  createSelector(getOrderRepeatState, (state: StateUtils.LoaderState<void>) => StateUtils.loaderLoadingSelector(state));
